import { render, staticRenderFns } from "./PriceSourceDelete.vue?vue&type=template&id=5940e461"
import script from "./PriceSourceDelete.vue?vue&type=script&lang=js"
export * from "./PriceSourceDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports